// Vendor libraries
import { SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
// Utils / constants
import { GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME } from 'QuickflowsApp/ts/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
import * as i2 from "ngx-cookie-service";
import * as i3 from "@angular/common";
import * as i4 from "@angular/forms";
import * as i5 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i7 from "./guided-workflows-categories.component";
import * as i8 from "./guided-workflows-steps.component";
const _c0 = a0 => ({ "btn-clear": a0 });
function GuidedWorkflowsMenuComponent_Conditional_8_For_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 11);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "a", 12);
    i0.ɵɵlistener("click", function GuidedWorkflowsMenuComponent_Conditional_8_For_1_Template_a_click_3_listener() { const result_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.setStepsBySubcategory(result_r2.subcategoryId)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(4, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const result_r2 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", result_r2.matchHTML, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", result_r2.locationHTML, i0.ɵɵsanitizeHtml);
} }
function GuidedWorkflowsMenuComponent_Conditional_8_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "No results found");
    i0.ɵɵelementEnd();
} }
function GuidedWorkflowsMenuComponent_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, GuidedWorkflowsMenuComponent_Conditional_8_For_1_Template, 5, 2, "div", 9, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵtemplate(2, GuidedWorkflowsMenuComponent_Conditional_8_Conditional_2_Template, 2, 0, "div");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.searchResults);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.searchResults.length === 0 ? 2 : -1);
} }
function GuidedWorkflowsMenuComponent_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-guided-workflows-categories", 14);
    i0.ɵɵtwoWayListener("stepsChange", function GuidedWorkflowsMenuComponent_Conditional_9_Template_ycn_guided_workflows_categories_stepsChange_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r2.selectedSteps, $event) || (ctx_r2.selectedSteps = $event); return i0.ɵɵresetView($event); })("selectedCategoryChange", function GuidedWorkflowsMenuComponent_Conditional_9_Template_ycn_guided_workflows_categories_selectedCategoryChange_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r2.selectedCategory, $event) || (ctx_r2.selectedCategory = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("selectedSubcategory", function GuidedWorkflowsMenuComponent_Conditional_9_Template_ycn_guided_workflows_categories_selectedSubcategory_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setSelectedSubcategory($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("expandableCategories", ctx_r2.expandableCategories);
    i0.ɵɵtwoWayProperty("steps", ctx_r2.selectedSteps)("selectedCategory", ctx_r2.selectedCategory);
} }
function GuidedWorkflowsMenuComponent_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-guided-workflows-steps", 8);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("categoryTitle", (ctx_r2.selectedCategory == null ? null : ctx_r2.selectedCategory.title) || "")("subcategory", ctx_r2.selectedSubcategory)("steps", ctx_r2.selectedSteps);
} }
/**
 *
 * Guided Workflows Menu Component
 *
 * The guided workflows menu that lives on the right hand side of the screen.
 * Controls the workflow content to interact with the page its hosted in.
 *
 * Input Properties:
 *   page_path: the page path url to get categories
 *   categories: list of PageGuidedWorkflows to display.
 *
 */
export class GuidedWorkflowsMenuComponent {
    constructor(sanitizer, cookieService) {
        this.sanitizer = sanitizer;
        this.cookieService = cookieService;
        this.categories = [];
        this.selectedSubcategoryId = null;
        this.expandableCategories = [];
        this.selectedSteps = [];
        this.selectedCategory = null;
        this.searchInput = '';
        this.searchResults = [];
    }
    ngOnChanges(changes) {
        this.expandableCategories = this.categories.map((category) => ({
            ...category,
            expanded: false,
        }));
        if (changes?.selectedSubcategoryId && this.selectedSubcategoryId) {
            this.setStepsBySubcategory(this.selectedSubcategoryId);
        }
    }
    get isSearching() {
        return this.searchInput.length > 0;
    }
    get searchIcon() {
        return this.isSearching ? 'icon-close' : 'icon-search';
    }
    clearSteps() {
        this.selectedSteps = [];
        this.expandableCategories = this.categories.map((category) => ({
            ...category,
            expanded: this.selectedCategory?.id === category.id,
        }));
    }
    clearSearch() {
        this.searchInput = '';
        this.searchResults = [];
    }
    setSelectedSubcategory(subcategory) {
        this.selectedSubcategory = subcategory;
        this.cookieService.set(GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME, this.selectedSubcategory.id.toString(), {
            path: '/',
        });
    }
    setStepsBySubcategory(subcategoryId) {
        this.clearSearch();
        this.categories.forEach((category) => {
            category.subcategories.forEach((subcategory) => {
                if (subcategory.id === subcategoryId) {
                    this.selectedCategory = { ...category, expanded: false };
                    this.selectedSubcategory = subcategory;
                    this.selectedSteps = subcategory.steps;
                }
            });
        });
    }
    searchMatchResults() {
        if (this.searchInput.length === 0 || this.searchInput.length < 3) {
            this.clearSearch();
            return;
        }
        const newResults = [];
        const textRegEx = new RegExp(this.searchInput, 'gi');
        const excludeTagsRegEx = new RegExp(`(?<!<[^>]*)${this.searchInput}`, 'gi');
        this.categories.forEach((category) => {
            category.subcategories.forEach((subcategory) => {
                const subcategoryHTML = subcategory.title.replace(textRegEx, `<b>${this.searchInput}</b>`);
                const subcategoryMatch = subcategoryHTML !== subcategory.title;
                subcategory.steps.forEach((step) => {
                    const textContent = step.text_content;
                    if (textContent.match(excludeTagsRegEx)) {
                        newResults.push({
                            matchHTML: this.sanitizer.bypassSecurityTrustHtml(textContent.replace(excludeTagsRegEx, `<b>${this.searchInput}</b>`)),
                            locationHTML: `${category.title} > ${subcategoryHTML}`,
                            subcategoryId: subcategory.id,
                        });
                    }
                    if (subcategoryMatch && !newResults.find((result) => result.subcategoryId === subcategory.id)) {
                        newResults.push({
                            matchHTML: subcategoryHTML,
                            locationHTML: category.title,
                            subcategoryId: subcategory.id,
                        });
                    }
                });
            });
        });
        this.searchResults = newResults;
    }
}
GuidedWorkflowsMenuComponent.ɵfac = function GuidedWorkflowsMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GuidedWorkflowsMenuComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i2.CookieService)); };
GuidedWorkflowsMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedWorkflowsMenuComponent, selectors: [["ycn-guided-workflows-menu"]], inputs: { pagePath: "pagePath", categories: "categories", selectedSubcategoryId: "selectedSubcategoryId" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 11, vars: 9, consts: [[1, "side-panel-section"], [1, "mt-2", "mb-2"], [1, "field-input-group", "field-search", "input-group"], ["placeholder", "Search Workflows", 1, "form-control", "field-input", 3, "ngModelChange", "ngModel"], [1, "field-input-group-actions"], ["ycnTooltip", "", 1, "btn", "btn-transparent", 3, "click", "ngClass", "tooltipTitle"], ["ycnIcon", "", 3, "name"], [3, "expandableCategories", "steps", "selectedCategory"], [3, "categoryTitle", "subcategory", "steps"], [1, "mb-row", "search-result"], [1, "d-flex", "align-items-center", "text-gray-30", "pb-4px"], ["ycnIcon", "", "name", "icon-search", 1, "icon-search", "fill-current", "text-gray-40", "flex-none", "mr-1"], ["href", "javascript:void(0);", 3, "click", "innerHTML"], [1, "ml-3", "text-smallest", "text-gray-50", 3, "innerHTML"], [3, "stepsChange", "selectedCategoryChange", "selectedSubcategory", "expandableCategories", "steps", "selectedCategory"]], template: function GuidedWorkflowsMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "input", 3);
        i0.ɵɵtwoWayListener("ngModelChange", function GuidedWorkflowsMenuComponent_Template_input_ngModelChange_3_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.searchInput, $event) || (ctx.searchInput = $event); return $event; });
        i0.ɵɵlistener("ngModelChange", function GuidedWorkflowsMenuComponent_Template_input_ngModelChange_3_listener() { return ctx.searchMatchResults(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4)(5, "button", 5);
        i0.ɵɵlistener("click", function GuidedWorkflowsMenuComponent_Template_button_click_5_listener() { return ctx.clearSearch(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(6, "svg", 6);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(7, "div", 0);
        i0.ɵɵtemplate(8, GuidedWorkflowsMenuComponent_Conditional_8_Template, 3, 1)(9, GuidedWorkflowsMenuComponent_Conditional_9_Template, 1, 3, "ycn-guided-workflows-categories", 7)(10, GuidedWorkflowsMenuComponent_Conditional_10_Template, 1, 3, "ycn-guided-workflows-steps", 8);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtwoWayProperty("ngModel", ctx.searchInput);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0, ctx.isSearching))("tooltipTitle", ctx.isSearching ? "Clear the field" : "");
        i0.ɵɵadvance();
        i0.ɵɵclassMap(ctx.searchIcon);
        i0.ɵɵproperty("name", ctx.searchIcon);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.isSearching ? 8 : ctx.categories && ctx.selectedSteps.length === 0 ? 9 : 10);
    } }, dependencies: [i3.NgClass, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i5.IconDirective, i6.TooltipDirective, i7.GuidedWorkflowsCategoriesComponent, i8.GuidedWorkflowsStepsComponent], encapsulation: 2 });
